import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateTicketTaggingAndLabelingWithAiAr: TemplateAr = {
  name: 'أتمتة وسم التذاكر وتصنيفها بالذكاء الاصطناعي',
  description:
    'لا تعتمد على ذاكرة الموظفين في اختيار الوسم الصحيح. يصنّف الذكاء الاصطناعي كل تذكرة بشكل متسق للتوجيه والتقارير وتحليل جذر المشكلة.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'تذكرة' },
    { icon: Sparkles, label: 'الـ AI يوسم' },
    { icon: FileText, label: 'مصنّفة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'الوسم اليدوي ما تعتمد عليه. موظف يوسم كل تذكرة، وموظف ثاني ما يوسم ولا وحدة. وتقاريرك وتوجيهك المبنيين على هذه الوسوم يرثون التفاوت كله. خلّ الـ AI يوسم كل تذكرة تجيك حسب تصنيفاتك الحالية — مجال المنتج، والنيّة، ودرجة الإلحاح، وشريحة العميل، وجذر المشكلة — ومعها درجة ثقة لكل وسم.',
    paragraph2:
      'الوسوم تشغّل التوجيه ومؤقتات SLA والتقارير في نظام الدعم عندك، زي ما كانت. والفرق إنها تنزل بنفس الطريقة على ١٠٠٪ من التذاكر، لحظياً، وعلى كل القنوات. والـ AI يتعلّم تصنيفاتك من بياناتك السابقة، ويتأقلم مع كل وسم جديد تضيفه. ودقة كل وسم ونسبة إصابته ونسبة تعديله تلقاها قدامك، عشان تعرف متى تحتاج ترتّب تصنيفاتك.',
  },
  benefits: [
    'يوسم ١٠٠٪ من التذاكر بنفس الطريقة',
    'كل وسم يجي معه درجة ثقة للمراجعة البشرية',
    'الـ AI يتعلّم تصنيفاتك من تذاكرك السابقة',
    'يشغّل التوجيه وSLA والتقارير عندك باعتمادية',
    'يشتغل لحظياً على كل القنوات',
    'شوف دقة كل وسم ونسبة تعديله',
  ],
};
